/**
 * A one-shot "focus this field" signal between screens.
 *
 * The global search can select a field in Redux, but the Farm View keeps its
 * own `selectedFieldId` and trailing-tab in component state — Redux alone
 * cannot tell it to highlight a field or open the Field Details tab. Rather
 * than reshape Redux (which every consumer of `selected_entities` would feel),
 * the search publishes a focus request and any screen that can honour it
 * subscribes.
 *
 * Deliberately tiny: no history, no replay. If nobody is listening the request
 * is dropped, which is the correct behavior — the screen that could act on it
 * is not on-screen.
 */

const subscribers = new Set();

/**
 * @param {(focus: {fieldId: string, farmingUnitId: string, openDetails: boolean}) => void} handler
 * @returns {() => void} unsubscribe
 */
const subscribeToFieldFocus = (handler) => {
  subscribers.add(handler);
  return () => subscribers.delete(handler);
};

const publishFieldFocus = (focus) => {
  subscribers.forEach((handler) => handler(focus));
};

module.exports = { subscribeToFieldFocus, publishFieldFocus };
